var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.recipientRecord
    ? _c(
        "div",
        { staticClass: "p-10" },
        [
          _c("el-page-header", {
            attrs: {
              title: _vm.$t("common.back"),
              content: _vm.$t("payment_plan.edit.title")
            },
            on: { back: _vm.handleGoBack }
          }),
          _vm._v(" "),
          _c("el-card", { staticClass: "mt-20" }, [
            _vm.paymentPlanRecord
              ? _c(
                  "div",
                  { staticClass: "edit-payment-plan__form" },
                  [
                    _c("div", { staticClass: "edit-payment-plan__recipient" }, [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.$t("payment_plan.create.recipient")))
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.recipientRecord.name))])
                    ]),
                    _vm._v(" "),
                    _vm.paymentPlanRecord.status !== "CANCELED"
                      ? _c(
                          "div",
                          { staticClass: "edit-payment-plan__cancel" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  loading: _vm.cancelLoading
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleCancelPaymentPlan(
                                      _vm.paymentPlanRecord.reference
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(_vm.$t("payment_plan.edit.cancel")) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "edit-payment-plan__status" }, [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.$t("payment_plan.edit.status")))
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$translate.payment_plan_status(
                              _vm.paymentPlanRecord.status
                            )
                          ) + "\n\t\t\t\t\t"
                        ),
                        _vm.paymentPlanRecord.status === "CANCELED"
                          ? _c("span", [
                              _vm._v(
                                "\n\t\t\t\t\t\t(" +
                                  _vm._s(
                                    _vm._f("parseTime")(
                                      _vm.paymentPlanRecord.canceled_at,
                                      "{d}-{m}-{y}"
                                    )
                                  ) +
                                  ")\n\t\t\t\t\t"
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.paymentPlanRecord.payment_promises.length > 0
                      ? _c(
                          "div",
                          { staticClass: "edit-payment-plan__promises" },
                          [
                            _c("h3", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "payment_plan.detail.payment_promises.title"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-table",
                              {
                                attrs: {
                                  data: _vm.paymentPlanRecord.payment_promises
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "payment_reference",
                                    label: _vm.$t(
                                      "payment_plan.detail.payment_promises.payment_reference"
                                    ),
                                    width: "192"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "due_date",
                                    label: _vm.$t(
                                      "payment_plan.detail.payment_promises.due_date"
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "total_amount",
                                    label: _vm.$t(
                                      "payment_plan.detail.payment_promises.total_amount"
                                    )
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$formatter.toCurrency(
                                                  scope.row.total_amount,
                                                  scope.row.amount_currency
                                                )
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3022851491
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "open_amount",
                                    label: _vm.$t(
                                      "payment_plan.detail.payment_promises.open_amount"
                                    )
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$formatter.toCurrency(
                                                  scope.row.open_amount,
                                                  scope.row.amount_currency
                                                )
                                              )
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3596754517
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "mini",
                                                  loading:
                                                    _vm.updatePaymentPromiseLoading,
                                                  disabled: !_vm.editHasLicenseAndPermission()
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleEditPaymentPromiseInstallmentAmount(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "payment_plan.detail.payment_promises.edit"
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3694147570
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "edit-payment-plan__invoices" },
                      [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.$t("payment_plan.detail.invoices.title"))
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-table",
                          {
                            ref: "invoicesViewTable",
                            staticClass: "edit-payment-plan__recipient",
                            attrs: {
                              data:
                                _vm.paymentPlanRecord.invoice_group_by_reference
                                  .invoice_group_invoices
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "invoice_by_reference.invoice_number",
                                label: _vm.$t("invoice_table.invoice_number")
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "invoice_by_reference.due_date",
                                label: _vm.$t("invoice_table.due_date")
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("invoice_table.open_amount")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$formatter.toCurrency(
                                              scope.row.invoice_by_reference
                                                .open_amount,
                                              scope.row.invoice_by_reference
                                                .amount_currency
                                            )
                                          )
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                481760085
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "edit-payment-plan__conditions" },
                      [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.$t("payment_plan.detail.conditions"))
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form",
                          { attrs: { "label-width": "260px", disabled: "" } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.create.conditions_interest_applied"
                                  )
                                }
                              },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    value:
                                      _vm.paymentPlanRecord.conditions
                                        .interest_applied
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.create.conditions_interest"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: _vm._f("toThousandFilter")(
                                        _vm.paymentPlanRecord.conditions
                                          .interest
                                      )
                                    }
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%")
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.create.conditions_indemnification_applied"
                                  )
                                }
                              },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    value:
                                      _vm.paymentPlanRecord.conditions
                                        .indemnification_applied
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.create.conditions_indemnification"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: _vm._f("toThousandFilter")(
                                        _vm.paymentPlanRecord.conditions
                                          .indemnification
                                      )
                                    }
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v("%")
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.create.conditions_indemnification_min"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: _vm._f("toThousandFilter")(
                                        _vm.paymentPlanRecord.conditions
                                          .indemnification_min
                                      )
                                    }
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$formatter.toCurrencySymbol(
                                            _vm.recipientRecord.currency
                                          )
                                        )
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "payment_plan.create.conditions_indemnification_max"
                                  )
                                }
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: {
                                      value: _vm._f("toThousandFilter")(
                                        _vm.paymentPlanRecord.conditions
                                          .indemnification_max
                                      )
                                    }
                                  },
                                  [
                                    _c("template", { slot: "append" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$formatter.toCurrencySymbol(
                                            _vm.recipientRecord.currency
                                          )
                                        )
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button-group",
                      { staticStyle: { "margin-top": "10px" } },
                      [
                        _vm.paymentPlanRecord.status !== "CANCELED"
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  disabled: !_vm.editHasLicenseAndPermission()
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showEditDocuments()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("payment_plan.edit.documents"))
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.editDialogVisible },
              on: {
                "update:visible": function($event) {
                  _vm.editDialogVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "paymentPlanForm",
                  staticClass: "edit-payment-plan__form",
                  attrs: { model: _vm.form, rules: _vm.rules }
                },
                [
                  _vm.recipientRecord.invoice_documents?.length > 0
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "edit-payment-plan__invoices",
                          attrs: { prop: "invoices" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.$t("payment_plan.edit.documents"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              ref: "invoicesEditTable",
                              attrs: {
                                data: _vm.recipientRecord.invoice_documents
                              },
                              on: {
                                "selection-change":
                                  _vm.handleInvoiceSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "invoice_number",
                                  label: _vm.$t("invoice_table.invoice_number")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "due_date",
                                  label: _vm.$t("invoice_table.due_date")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "open_amount",
                                  label: _vm.$t("invoice_table.open_amount")
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$formatter.toCurrency(
                                                scope.row.open_amount,
                                                scope.row.amount_currency
                                              )
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  641494869
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recipientRecord.credit_notes?.length > 0
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "edit-payment-plan__credit_notes",
                          attrs: { prop: "creditNotes" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.$t("payment_plan.create.credit_notes"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              ref: "creditNotesTable",
                              attrs: { data: _vm.recipientRecord.credit_notes },
                              on: {
                                "selection-change":
                                  _vm.handleCreditNoteSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "credit_note_number",
                                  label: _vm.$t(
                                    "credit_note_table.credit_note_number"
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "issue_date",
                                  label: _vm.$t("credit_note_table.issue_date")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "open_amount",
                                  label: _vm.$t("credit_note_table.open_amount")
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatter.toCurrency(
                                                scope.row.open_amount,
                                                scope.row.amount_currency
                                              )
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1071176625
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recipientRecord.debit_notes?.length > 0
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "edit-payment-plan__debit_notes",
                          attrs: { prop: "debitNotes" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.$t("payment_plan.create.debit_notes"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              ref: "debitNotesTable",
                              attrs: { data: _vm.recipientRecord.debit_notes },
                              on: {
                                "selection-change":
                                  _vm.handleDebitNoteSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "debit_note_number",
                                  label: _vm.$t(
                                    "debit_note_table.debit_note_number"
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "issue_date",
                                  label: _vm.$t("debit_note_table.issue_date")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "open_amount",
                                  label: _vm.$t("debit_note_table.open_amount")
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$formatter.toCurrency(
                                                scope.row.open_amount,
                                                scope.row.amount_currency
                                              )
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  641494869
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.recipientRecord.payment_documents?.length > 0
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "edit-payment-plan__payments",
                          attrs: { prop: "payments" }
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              _vm._s(_vm.$t("payment_plan.create.payments"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              ref: "paymentsTable",
                              attrs: {
                                data: _vm.recipientRecord.payment_documents
                              },
                              on: {
                                "selection-change":
                                  _vm.handlePaymentSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection" }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "payment_number",
                                  label: _vm.$t("payment_table.payment_number")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "issue_date",
                                  label: _vm.$t("payment_table.issue_date")
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "open_amount",
                                  label: _vm.$t("payment_table.open_amount")
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$formatter.toCurrency(
                                                scope.row.open_amount,
                                                scope.row.amount_currency
                                              )
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  641494869
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "edit-payment-plan__total_amount_with_conditions"
                    },
                    [
                      _c("h3", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "payment_plan.create.total_amount_with_conditions"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$formatter.toCurrency(
                              _vm.totalWithConditions,
                              _vm.recipientRecord.currency
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "edit-payment-plan__constraints" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("payment_plan.create.constraints")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "payment_plan.create.constraints_max_installments"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("el-slider", {
                          attrs: {
                            value: _vm.MAX_PERIOD,
                            min: _vm.MIN_PERIOD,
                            max: _vm.MAX_PERIOD,
                            step: 1,
                            "show-input": ""
                          },
                          model: {
                            value: _vm.form.constraints.maxInstallments,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form.constraints,
                                "maxInstallments",
                                $$v
                              )
                            },
                            expression: "form.constraints.maxInstallments"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "edit-payment-plan__total_amount_with_conditions"
                    },
                    [
                      _c("h3", [
                        _vm._v(
                          _vm._s(_vm.$t("payment_plan.create.monthly_amount"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$formatter.toCurrency(
                              _vm.minAmount,
                              _vm.recipientRecord.currency
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "edit-payment-plan__cta" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", loading: _vm.loading },
                          on: { click: _vm.handleFormSubmit }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("payment_plan.edit.submit")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleFormCancel }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("payment_plan.edit.exit")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("payment-promise-dialog", { ref: "paymentPromiseDialog" })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }